// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";

import "./styles/reset.less";
import "./styles/common.less";
import "./styles/element.less";
import "./styles/index.css";
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./element";

import i18n from "./lang";

import VueCookie from "vue-cookie";

// import "./styles/tailwindcss.css";
import "tailwindcss/tailwind.css";
Vue.use(VueCookie);
// 签名功能
import vueEsign from 'vue-esign'
Vue.use(vueEsign)

//数字增长动画
import VueAnimateNumber from 'vue-animate-number'
Vue.use(VueAnimateNumber)

Vue.config.productionTip = false;
Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value),
  size: "small"
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
  i18n
});



// WEBPACK FOOTER //
// ./src/main.js